var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"x-wrap clearfix"},[_c('div',{staticClass:"bg-pic yuan"}),_vm._m(0),_c(_vm.componentName[_vm.LoginPage],{tag:"component"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-pic fang pic"},[_c('img',{staticClass:"i",attrs:{"src":require("@/assets/img/pic_001.png"),"alt":""}})])
}]

export { render, staticRenderFns }